import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from '@nackle/paper';
import { LocaleString } from '@nackle/intl-tools';
import { CSSTransition } from 'react-transition-group';
import { Search } from '../../shared/icons/icons';
import DebounceSelect from 'app/components/shared/debounce-select/debounce-select';
import { PersonDetails } from 'app/components/shared/person-details/person-details';

import {
    getMyTeam,
    getSelectedPeople,
    getTeamMembers,
    removeSelectedPeople,
    searchParticipant,
    setSelectedPeople
} from 'app/app-dux/people-dux';

import './people.less';

export function People( props ) {
    const [ animate, setAnimate ] = useState( false );
    const [ filteredTeam, setFilteredTeam ] = useState( [] );
    const [ searchValues, setUpdatedValues ] = useState( [] );

    const dispatch = useDispatch();
    const myTeam = useSelector( getMyTeam );
    const selectedPeople = useSelector( getSelectedPeople );

    useEffect( () => {
        setAnimate( true );
        dispatch( getTeamMembers() );
    }, [] );

    useEffect( () => {
        let updatedValues = [];
        if ( selectedPeople.length > 0 ) {
            updatedValues = selectedPeople.map( p => {
                let ele = <PersonDetails person={ p } emailEnabled={ false } size={ 24 }/>;
                return { key: p.id, value: p.id, label: ele };
            } );
        }
        setUpdatedValues( updatedValues );
    }, [ selectedPeople ] );

    useEffect( () => {
        let updatedTeam = [];
        updatedTeam = myTeam.filter( function( teamMember ) {
            return !selectedPeople.find( function( selectedPerson ) {
                return teamMember.id === selectedPerson.id;
            } );
        } );
        setFilteredTeam( updatedTeam );
    }, [ selectedPeople, myTeam ] );

     const addToSearchOptions = ( event, item ) => {
         const isUserAlreadySelected = selectedPeople.find( a => a.id === item.key );

         if ( !isUserAlreadySelected ) {
             let personToAdd = item;
             if ( item.value ) {
                 personToAdd = JSON.parse( item.value );
             }
             dispatch( setSelectedPeople( personToAdd ) );
         }
    };

    const updateList = ( item ) => {
        if ( item ) {
            dispatch( removeSelectedPeople( item ) );
        }
    };

    const fetchUserList = ( username ) => {
        if ( username.length > 2 ) {
            dispatch( searchParticipant( username ) );
        }
	};

	return (
        <CSSTransition
			timeout={ 1000 }
            in={ animate }
            classNames={ props.forward ? 'slide-in' : 'slide-out' }>
                <div className='spacer-lr-16'>
                    <LocaleString code="recognition.people.searchLabel" TextComponent="h3" className="recognitionLabel"/>
                    <DebounceSelect
                        mode="multiple"
                        value={ searchValues }
                        placeholder={ <div><Search className="search-icon" /> <LocaleString code="recognition.people.searchPlaceholder"/> </div> }
                        fetchOptions={ fetchUserList }
                        onTagRemove={ updateList }
                        onOptionSelect={ ( e, newValue ) => addToSearchOptions( e, newValue ) }
                        style={ {
                            width: '100%'
                        } }
                    />
                    <LocaleString code="recognition.people.addTeamMembers" TextComponent="p" className="helper-text" />
                    <List
                        itemLayout="horizontal"
                        dataSource={ filteredTeam }
                        className="people-list"
                        renderItem={ teamRecipient => (
                            <List.Item
                                onClick={ ( e ) => addToSearchOptions( e, teamRecipient ) }>
                                <PersonDetails person={ teamRecipient }/>
                            </List.Item>
                        ) }
                    />
            </div>
        </CSSTransition>
    );
}